import { render, staticRenderFns } from "./AddReportTemplate.vue?vue&type=template&id=5f1ccf90&scoped=true"
import script from "./AddReportTemplate.vue?vue&type=script&lang=js"
export * from "./AddReportTemplate.vue?vue&type=script&lang=js"
import style0 from "./AddReportTemplate.vue?vue&type=style&index=0&id=5f1ccf90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1ccf90",
  null
  
)

export default component.exports